import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellIcon, CheckIcon, PackageIcon, ReceiptIcon, RefreshIcon, AlertIcon } from '../../components/Icons';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

const TIPO_ICON = {
  reserva:   <ReceiptIcon size={16} color='#2563EB'/>,
  anuncio:   <PackageIcon size={16} color='#F97316'/>,
  kyc:       <CheckIcon  size={16} color='#16A34A'/>,
  alerta:    <AlertIcon  size={16} color='#D97706'/>,
  default:   <BellIcon   size={16} color='var(--text-muted)'/>,
};

const TIPO_BG = {
  reserva: '#EFF6FF', anuncio: '#FFF7ED', kyc: '#F0FDF4', alerta: '#FFFBEB', default: 'var(--surface)',
};

export default function Notificacoes() {
  const navigate = useNavigate();
  const [notifs, setNotifs]   = useState([]);
  const [load,   setLoad]     = useState(true);

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setLoad(true);
    try {
      const res  = await fetch(`${BASE}/notificacoes`, { headers: { Authorization: `Bearer ${token()}` } });
      const data = await res.json();
      if (data.sucesso) setNotifs(data.notificacoes || []);
    } catch {
      // endpoint ainda não existe — mostra vazio
    } finally { setLoad(false); }
  };

  const marcarLida = async (id) => {
    setNotifs(prev => prev.map(n => n.id === id ? { ...n, lida: true } : n));
    try {
      await fetch(`${BASE}/notificacoes/${id}/lida`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token()}` },
      });
    } catch {}
  };

  const marcarTodasLidas = async () => {
    setNotifs(prev => prev.map(n => ({ ...n, lida: true })));
    try {
      await fetch(`${BASE}/notificacoes/todas-lidas`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${token()}` },
      });
    } catch {}
  };

  const naoLidas = notifs.filter(n => !n.lida).length;

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Notificações</div>
          <div className="topbar-sub">{naoLidas > 0 ? `${naoLidas} não lida${naoLidas !== 1 ? 's' : ''}` : 'Tudo em dia'}</div>
        </div>
        <div className="topbar-actions">
          {naoLidas > 0 && (
            <button className="btn btn-ghost" onClick={marcarTodasLidas} style={{display:'flex',alignItems:'center',gap:'6px',fontSize:'12px'}}>
              <CheckIcon size={13}/> Marcar todas como lidas
            </button>
          )}
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
        </div>
      </div>

      <div className="page-content">
        {load ? (
          <div style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>A carregar notificações...</div>
        ) : notifs.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px 20px'}}>
            <BellIcon size={40} color='var(--border)'/>
            <div style={{fontSize:'15px',fontWeight:'600',marginTop:'12px',marginBottom:'6px'}}>Sem notificações</div>
            <div style={{fontSize:'13px',color:'var(--text-muted)'}}>
              As actualizações sobre as tuas reservas e conta aparecem aqui.
            </div>
          </div>
        ) : (
          <div className="card" style={{padding:0,overflow:'hidden'}}>
            {notifs.map((n, i) => {
              const tipo = n.tipo || 'default';
              return (
                <div key={n.id} onClick={() => { marcarLida(n.id); if (n.link) navigate(n.link); }}
                  style={{
                    display:'flex',gap:'12px',alignItems:'flex-start',padding:'14px 16px',
                    borderBottom: i < notifs.length - 1 ? '1px solid var(--border)' : 'none',
                    cursor: n.link ? 'pointer' : 'default',
                    background: n.lida ? 'transparent' : 'var(--orange-faint, rgba(249,115,22,0.03))',
                    transition:'background 0.15s',
                  }}
                  onMouseOver={e => { if (n.link) e.currentTarget.style.background = 'var(--surface)'; }}
                  onMouseOut={e => { e.currentTarget.style.background = n.lida ? 'transparent' : 'var(--orange-faint, rgba(249,115,22,0.03))'; }}
                >
                  <div style={{width:'36px',height:'36px',borderRadius:'50%',background:TIPO_BG[tipo]||TIPO_BG.default,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    {TIPO_ICON[tipo] || TIPO_ICON.default}
                  </div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontSize:'13px',fontWeight: n.lida ? '400' : '600',color:'var(--text-primary)',marginBottom:'2px'}}>{n.titulo}</div>
                    <div style={{fontSize:'12px',color:'var(--text-secondary)',lineHeight:'1.5'}}>{n.mensagem}</div>
                    <div style={{fontSize:'11px',color:'var(--text-muted)',marginTop:'4px'}}>
                      {new Date(n.created_at).toLocaleString('pt-PT',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'})}
                    </div>
                  </div>
                  {!n.lida && (
                    <div style={{width:'8px',height:'8px',borderRadius:'50%',background:'var(--orange)',flexShrink:0,marginTop:'4px'}}/>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}
